<div class="splash-screen" *ngIf="loading | async">
  <div class="splash-loader"></div>
  <img class="splash-logo" src="assets/favicons/logo.png" />
</div>
